import { Injectable } from "@angular/core";
import {
    Router
    ,Route
    ,CanActivate
    ,CanActivateChild
    ,CanLoad
    ,ActivatedRouteSnapshot
    ,RouterStateSnapshot
    ,NavigationExtras
} from "@angular/router";

import { FvmsApiAuthService } from "./fvms.api.auth.service";

@Injectable({
    providedIn: "root"
})
export class FvmsApiReverseAuthGuard implements CanActivate,CanActivateChild,CanLoad {
    constructor(
        private router:Router
        ,private fvmsApiAuthService:FvmsApiAuthService
    ) {

    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let url:string = state.url;
        return this.checkLogin(url);
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route,state);
    }

    canLoad(route: Route): boolean {
        let url = `/${route.path}`;
        return this.checkLogin(url);
    }

    checkLogin(url:string):boolean{
        // console.log(url);
        console.log("getLoginUserInfo",this.fvmsApiAuthService.getLoginUserInfo());
        if(!this.fvmsApiAuthService.getLoginUserInfo()){
            return true;
        }

        // 인증정보가 남아있을때
        // 도메인만 입력하면 라우터에서 로그인으로 리다이렉트 한다
        // 인증정보가 남아있으므로 메인으로 다시 돌려준다
        if(url.indexOf("fvms/auth/login/main") > -1){
            let tmpParam = {
                runtime:new Date().getTime()
            };
            let navigationExtras:NavigationExtras = {
                queryParams:tmpParam
                ,fragment:"anchor"
            };
            this.router.navigate(["/dtg/car/current/list"],navigationExtras);
            return false;
        }else{
            // 기타 다른 주소로 접속하면 일단 허락한다
            // 인증 필요한 주소는 해당 주소의 authguard 가 필터링 해준다
            return true;
        }

        // let tmpParam = {
        //     runtime:new Date().getTime()
        // };
        // let navigationExtras:NavigationExtras = {
        //     queryParams:tmpParam
        //     ,fragment:"anchor"
        // };
        // this.router.navigate(["/dtg/car/current/list"],navigationExtras);
        // return false;
    }
}
